import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import LiveChat from "../components/LiveChat";
import '../App.css';
import GetQuoteButton from "../components/GetQuoteButton";
import QAChatbot from "../components/QAChatBot";
import BackToTopButton from "../components/BackToTopButton";
import ScrollSocialIcons from "../components/ScrollSocialIcons";

const offers = [
  {
   // icon: "🧑‍✈️",
    title: "Crew Logistics",
    description: "We provide crew logistics globally, including managing the movement and accommodation of personnel. Our services include visa arrangements, transportation, accommodation and other logistical services.",
  },
  {
    //icon: "🏢",
    title: "Agency Services",
    description: "Our Scope - Agency Services Representing International Entities, project support, crewing, procurement approval from the respective authorities and class."
  }
];

const Husbandry = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  return (
    <div className="sector-detail">
      <Navbar />
      <header className="husbandry-hero">
        <h1>Husbandry Services</h1>
        <p>
        We offer comprehensive husbandry services to ensure the smooth and efficient
handling of vessels at ports. Our dedicated team guarantees timely support, operational
excellence and a seamless experience for ship owners and operators.
        </p>
      </header>
      
      <div className="sector-content">
        <h3 className="offer-title">What We Offer:</h3>
        <p>Our team is committed to delivering fast, reliable and professional husbandry support, covering all essential vessel needs while at port or offshore locations.</p>
        
        <ul className="offer-list">
          {offers.map((offer, index) => (
            <li 
              key={index}
              className="offer-item"
              onMouseEnter={() => setActiveIndex(index)}
              onMouseLeave={() => setActiveIndex(null)}
            >
              <span className="offer-icon">{offer.icon}</span>
              {offer.title}
              {activeIndex === index && offer.description && (
                <div className="popup">
                  {offer.description}
                </div>
              )}
            </li>
          ))}
        </ul>
      </div>

      <LiveChat />
      <QAChatbot/>
      <GetQuoteButton/>
      <ScrollSocialIcons/>
      <BackToTopButton/>
      <Footer />
    </div>
  );
};

export default Husbandry;
